<template>
  <label
    class="flex flex-col gap-1 p-2 outline outline-1 outline-EXPONDO-grey-20 rounded
    cursor-pointer hover:outline-EXPONDO-secondary
    [&:has(input:checked)]:outline-EXPONDO-secondary
    [&:has(input:checked)]:outline-2"
  >
    <div
      data-testid="extraGuaranteeOption"
      class="flex justify-between h-6"
    >
      <input
        type="checkbox"
        class="w-4 h-4 accent-EXPONDO-secondary"
        :checked="isSelected"
        @change="$emit('select', option)"
      >
      <ProductCardBadge
        v-if="isBestDeal"
        badge-translation-key="Best Deal"
        badge-class="bg-EXPONDO-green text-EXPONDO-white"
        :small="true"
      />
    </div>
    <span class="font-bold text-sm">{{ option.name }}</span>
    <div class="flex items-center gap-2">
      <span
        class="font-bold"
        :class="isBestDeal ? 'text-EXPONDO-red' : 'text-EXPONDO-black'"
      >
        {{ option.formattedPrice }}
      </span>
      <span class="text-sm">
        {{ $t('extra-guarantee.per-item') }}
      </span>
    </div>
  </label>
</template>

<script lang="ts">

import type { PropType } from 'vue';
import type { GuaranteeOption } from '~~/types/extraGuarantee/guaranteeOption';

export default defineComponent({
  name: 'ExtraGuaranteeOption',

  props: {
    option: {
      type: Object as PropType<GuaranteeOption>,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    isBestDeal: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['select'],
});

</script>
